import '../assets/edit.scss'
import TomSImageSlider from './slider'

import React from "react";

function EditTomSIamgeSlider(tomsProps) {
    /*console.log(tomsProps.props)*/
    return (
    <>
    <div className="toms-image-slider">
        <TomSImageSlider props={tomsProps.props}/>
    </div>
    </>
    )
}

export default EditTomSIamgeSlider;